import { render, staticRenderFns } from "./TreasuryEdit.vue?vue&type=template&id=fa108030&scoped=true&"
import script from "./TreasuryEdit.vue?vue&type=script&lang=js&"
export * from "./TreasuryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa108030",
  null
  
)

export default component.exports